import React from 'react'
import { Spin } from 'antd'
import PropTypes from 'prop-types'
import './Spin.scss'

const Spinner = ({ tip, fullscreen = true }) => {
  if (fullscreen) {
    return <Spin tip={tip || 'Loading'} fullscreen size="large" />
  }

  return (
    <div className="page-level-spinner">
      <Spin tip={tip || 'Loading'} size="large" />
    </div>
  )
}
Spinner.propTypes = {
  tip: PropTypes.string,
  fullscreen: PropTypes.bool,
}
export default Spinner
